export class RegenerateArtifactContext {
    constructor(public businessTransactionNumberId: number, public businessTransactionDetails: string, public documentTypes: any) { }
}
